module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Italic.7d28aec8.woff2";